import axios from 'axios'
import { EXCLUIR_VEICULO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function excluirVeiculo (cod, idEmpresa) {
  const url = `${URL}/veiculo/${cod}/empresa/${idEmpresa}/excluir`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: EXCLUIR_VEICULO,
        payload: response

      })
  );
}
